import { create } from "zustand";

interface SystemUsersUIState {
	isInviteModalOpen: boolean;
	isEditing: boolean;
	selectedSystemUserId: string | null;
	isDeleteModalOpen: boolean;
	systemUserToDelete: { id: string; name: string } | null;
	formData: {
		email: string;
		roleId: string;
	};
	setFormData: (data: { email: string; roleId: string }) => void;
	openInviteModal: (editing?: boolean, userId?: string) => void;
	closeInviteModal: () => void;
	openDeleteModal: (userId: string, userName: string) => void;
	closeDeleteModal: () => void;
	resetForm: () => void;
}

export const useSystemUsersStore = create<SystemUsersUIState>((set) => ({
	isInviteModalOpen: false,
	isEditing: false,
	selectedSystemUserId: null,
	isDeleteModalOpen: false,
	systemUserToDelete: null,
	formData: {
		email: "",
		roleId: ""
	},
	setFormData: (data) => set({ formData: data }),
	openInviteModal: (editing = false, userId = undefined) =>
		set({
			isInviteModalOpen: true,
			isEditing: editing,
			selectedSystemUserId: userId
		}),
	closeInviteModal: () =>
		set({
			isInviteModalOpen: false,
			isEditing: false,
			selectedSystemUserId: null,
			formData: { email: "", roleId: "" }
		}),
	openDeleteModal: (userId: string, userName: string) =>
		set({
			isDeleteModalOpen: true,
			systemUserToDelete: { id: userId, name: userName }
		}),
	closeDeleteModal: () =>
		set({ isDeleteModalOpen: false, systemUserToDelete: null }),
	resetForm: () => set({ formData: { email: "", roleId: "" } })
}));
